import { DailyHours } from '@leverege/operating-hours'
import { DateTime } from 'luxon'

export { default as Constants } from './Constants'
export * from './Format'
export * from './Stations'

const HOURS_FORMATS = 'hh:mma'
const DAYS = [ 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday' ]

/**
 * 
 * @param {object} hours 
 * @param {import('luxon').DateTime} baseDate 
 * @returns 
 */
export function getOpenAndCloseTimesFromHours( hours, baseDate, timezone ) {
  const ranges = DailyHours.getRanges( hours )
  
  if ( ranges?.length > 0 ) {
    const { start, end } = ranges[0]
    const startDate = DateTime.fromFormat(
      start,
      HOURS_FORMATS,
      { zone : timezone }
    )
      .set( {
        day : baseDate.day,
        month : baseDate.month,
        year : baseDate.year
      } )
    const endDate = DateTime.fromFormat(
      end,
      HOURS_FORMATS,
      { zone : timezone }
    )
      .set( {
        day : baseDate.day,
        month : baseDate.month,
        year : baseDate.year
      } )

    return {
      open : startDate,
      close : endDate
    }
  }

  return {}
}

export function getBusinessDays( range, operatingHours, opts ) {
  const { getFullRange = false, padHours = 0 } = opts || {}
  const { start, end } = range

  const days = []

  if ( !operatingHours ) {
    return days
  }

  const { timezone, currentMode, modes } = operatingHours

  const mode = modes[currentMode]

  let sLocal = DateTime.fromJSDate( start, { zone : timezone } ).set( { day : start.getDate() } ).startOf( 'day' )
  const eLocal = DateTime.fromJSDate( end, { zone : timezone } ).set( { day : end.getDate() } ).endOf( 'day' )

  const now = Date.now()
  while ( sLocal < eLocal ) {
    const dayOfWeek = sLocal.toFormat( 'EEEE' ).toLowerCase()
    const operatingHoursForDay = mode?.[dayOfWeek]

    if ( operatingHoursForDay?.open ) {
      const { start, end } = getStartAndEndTimeFromRanges( operatingHoursForDay.ranges, timezone, padHours )

      const startOfWorkDay = sLocal.set( { hour : start.hour } )
      const endOfWorkDay = sLocal.set( { hour : end.hour, day : startOfWorkDay.day } )
  
      days.push(
        [ startOfWorkDay.valueOf(), ( !getFullRange && endOfWorkDay.valueOf() > now ) ? now : endOfWorkDay.valueOf() ]
      )
    }

    sLocal = sLocal.plus( { days : 1 } )
  }

  return days
}

export function getOpenHoursFromOperatingHours( operatingHours, useZone = true ) {
  const timezone = !useZone ? null : operatingHours?.timezone
  const mode = operatingHours?.modes[operatingHours?.currentMode]

  if ( !mode ) {
    return []
  }

  let minHour
  let maxHour

  DAYS.forEach( ( day ) => {
    if ( mode[day].open ) {
      const { start, end } = getStartAndEndTimeFromRanges( mode[day].ranges, timezone )

      if ( !minHour || start < minHour ) {
        minHour = start.toLocal()
      }

      if ( !maxHour || end > maxHour ) {
        maxHour = end.toLocal()
      }
    }
  } )

  let startHour = minHour.get( 'hour' )
  let endHour = maxHour.get( 'hour' )

  startHour = startHour === 0 ? 24 : startHour
  endHour = endHour === 0 ? 24 : endHour

  const hours = []

  for ( let i = startHour; i <= endHour; i++ ) {
    hours.push( `${i}` )
  }

  return hours
}

function getStartAndEndTimeFromRanges( ranges = [], timezone = 'America/Phoenix', padHours = 0 ) {
  let start
  let end

  ranges.forEach( ( range ) => {
    const { start : rStart, end : rEnd } = range

    const startTime = DateTime
      .fromFormat( rStart, HOURS_FORMATS, { zone : timezone } )
      .minus( { hours : padHours } )
    const endTime = DateTime
      .fromFormat( rEnd, HOURS_FORMATS, { zone : timezone } )
      .plus( { hours : padHours } )

    if ( !start || startTime < start ) {
      start = startTime
    }

    if ( !end || endTime > end ) {
      end = endTime
    }
  } )

  return { start, end }
}
